import { render, staticRenderFns } from "./OfferWhat.vue?vue&type=template&id=15d51c24&scoped=true"
import script from "./OfferWhat.vue?vue&type=script&lang=js"
export * from "./OfferWhat.vue?vue&type=script&lang=js"
import style0 from "./OfferWhat.vue?vue&type=style&index=0&id=15d51c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d51c24",
  null
  
)

export default component.exports